<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" :form="form">
        <!--        筛选的条件-->
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item label="企业名称" style="margin-left: 29px" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select
                showSearch
                @change="handleEnterPrise"
                optionFilterProp="children"
                :filterOption="filterOption"
                v-model="queryParam.enterpriseId"
                :disabled="EnterDisabled"
                :allowClear="true"
              >
                <a-select-option v-for="type in selectCombox" :title="type.enterpriseName" :key="type.enterpriseId">{{
                  type.enterpriseName
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="安装类别" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 29px">
              <a-select v-decorator="['installType']" @change="changeInstall" :allowClear="true">
                <a-select-option
                  v-for="type in installTypes"
                  :title="type.installationTypeName"
                  :key="type.installationTypeCode"
                  >{{ type.installationTypeName }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="订单类型" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 29px">
              <a-select v-decorator="['orderType']" :allowClear="true">
                <a-select-option v-for="type in orderTypeList" :title="type.typeName" :key="type.orderTypeId">{{
                  type.typeName
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="订单状态" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 29px">
              <a-select v-model="queryParam.orderStatus" :allowClear="true" @change="changeOrderStatus">
                <a-select-option v-for="type in order_status" :title="type.dictLabel" :key="type.dictValue">{{
                  type.dictLabel
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="订单号" style="margin-left: 41px" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-model.trim="queryParam.orderNo" />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="品牌" style="margin-left: 56px" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select
                showSearch
                optionFilterProp="children"
                @change="changeBrandName"
                :filterOption="filterOption"
                v-decorator="['brandId']"
                :allowClear="true"
              >
                <a-select-option v-for="type in selectBrand" :title="type.brandName" :key="type.brandId">{{
                  type.brandName
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="型号" style="margin-left: 56px" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select
                showSearch
                optionFilterProp="children"
                @change="changeModelName"
                :filterOption="filterOption"
                v-decorator="['modelId']"
                :allowClear="true"
              >
                <a-select-option v-for="type in selectModel" :title="type.modelName" :key="type.modelId">{{
                  type.modelName
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="是否超时订单" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-checkbox v-model="checkboxlist.isOverTimeOrder" @change="overTimeOrder"></a-checkbox>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="客户姓名" style="margin-left: 29px;">
              <div style="display: flex;justify-content: space-between;align-items: center">
                <a-input v-model.trim="queryParam.clientName" />
              </div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="客户联系方式">
              <div style="display: flex;justify-content: space-between;align-items: center">
                <a-input v-model.trim="queryParam.clientPhone" />
              </div>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-row :gutter="24">
              <a-form-item
                label="客户地址"
                style="margin-left:40px;margin-right: 12px;"
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
              >
                <a-col :span="5">
                  <a-select v-decorator="['customerProvinceCode']" @change="getProvince" :allowClear="true">
                    <a-select-option
                      :title="type.provinceName"
                      v-for="type in selectAllProvince"
                      :key="type.provinceCode"
                      >{{ type.provinceName }}</a-select-option
                    >
                  </a-select>
                </a-col>
                <a-col :span="5">
                  <a-select v-decorator="['customerCityCode']" @change="getCityName" :allowClear="true">
                    <a-select-option :title="type.cityName" v-for="type in selectCityName" :key="type.cityCode">{{
                      type.cityName
                    }}</a-select-option>
                  </a-select>
                </a-col>
                <a-col :span="5">
                  <a-select v-decorator="['customerAreaCode']" @change="getAreaName" :allowClear="true">
                    <a-select-option :title="type.areaName" v-for="type in selectAreaName" :key="type.areaCode">{{
                      type.areaName
                    }}</a-select-option>
                  </a-select>
                </a-col>
                <a-col :span="9">
                  <a-input v-decorator="['customerDetailAddress']" />
                </a-col>
              </a-form-item>
            </a-row>
          </a-col>
          <a-col :span="8">
            <a-form-item>
              <a-col :span="6">
                <a-select v-model="queryParam.timeType1" :allowClear="true" @change="changeTimeType1">
                  <a-select-option v-for="type in master_time_type" :key="type.dictValue" :title="type.dictLabel">{{
                    type.dictLabel
                  }}</a-select-option>
                </a-select>
              </a-col>
              <a-col :span="18">
                <a-range-picker
                  :show-time="{
                    hideDisabledOptions: true,
                    defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                  }"
                  v-model="timeType1"
                  style="width:100%"
                  format="YYYY-MM-DD HH:mm:ss"
                  :placeholder="['开始时间', '结束时间']"
                  @change="onChangerangepicker"
                />
              </a-col>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item>
              <a-col :span="6">
                <a-select v-model="queryParam.timeType2" :allowClear="true">
                  <a-select-option v-for="type in master_time_type" :key="type.dictValue" :title="type.dictLabel">{{
                    type.dictLabel
                  }}</a-select-option>
                </a-select>
              </a-col>
              <a-col :span="18">
                <a-range-picker
                  :show-time="{
                    hideDisabledOptions: true,
                    defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                  }"
                  v-model="timeType2"
                  style="width:100%"
                  format="YYYY-MM-DD HH:mm:ss"
                  :placeholder="['开始时间', '结束时间']"
                  @change="onChangerangepicker2"
                />
              </a-col>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item>
              <a-col :span="6">
                <a-select v-model="queryParam.timeType3" :allowClear="true">
                  <a-select-option v-for="type in master_time_type" :key="type.dictValue" :title="type.dictLabel">{{
                    type.dictLabel
                  }}</a-select-option>
                </a-select>
              </a-col>
              <a-col :span="18">
                <a-range-picker
                  :show-time="{
                    hideDisabledOptions: true,
                    defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                  }"
                  v-model="timeType3"
                  style="width:100%"
                  format="YYYY-MM-DD HH:mm"
                  :placeholder="['开始时间', '结束时间']"
                  @change="onChangerangepicker3"
                />
              </a-col>
            </a-form-item>
          </a-col>
        </a-row>
        <!--        查询和清空按钮-->
        <a-row>
          <a-col :span="7" :offset="17" :style="{ textAlign: 'right' }">
            <a-button type="primary" htmlType="submit" @click="query">查询</a-button>
            <a-button style="margin-left: 8px;" @click="handleClear">清空</a-button>
          </a-col>
        </a-row>
        <a-divider />
        <div class="table-operator">
          <a-row>
            <a-col :span="12" :offset="12" :style="{ textAlign: 'right' }">
              <a-button class="ncreate" type="primary" style="margin-left: 8px;" @click="exportEnt2"
                >导出Excel</a-button
              >
              <a-button class="ncreate" type="primary" style="margin-left: 8px;" @click="ordersSort">排序</a-button>
            </a-col>
          </a-row>
        </div>
      </a-form>
    </div>
    <!--    表格内容-->
    <s-table
      size="default"
      ref="table"
      :columns="columns"
      :data="loadData"
      :scroll="{ x: 2500 }"
      :row-selection="rowSelection"
      bordered
    >
      <span slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)">编辑</a>
        <a-divider v-if="record.orderStatusName == '待接单'" type="vertical" />
        <a v-if="record.orderStatusName == '待接单'" @click="orderReceive(record)">接单</a>
        <a-divider v-if="record.orderStatusName != '待接单'" type="vertical" />
        <a v-if="record.orderStatusName != '待接单' && record.orderStatusName != '待指派'" @click="distribute(record)"
          >改派</a
        >
      </span>

      <span slot="orderNo" slot-scope="text, record">
        <a @click="addremark(record)">{{ text }} </a>
        <a title="复制"><a-icon type="copy" class="copy" @click="Copys(record)"/></a>
      </span>
      <span slot="clientName" slot-scope="text, record">
        <span class="hover">{{ text }} </span>
        <a title="复制"><a-icon type="copy" class="copy" @click="Copys2(record)"/></a>
      </span>
    </s-table>
    <a-modal v-model="changeRemarkible" :confirmLoading="changeLoading" footer="" title="备注信息" width="75%">
      <a-row>
        <a-col :span="20" :offset="2">
          <div class="table-page-search-wrapper" style="margin-bottom: 15px">
            <a-table
              size="default"
              ref="table1"
              :loading="tableLoading"
              :columns="mastercolumns"
              :dataSource="masterList"
              :pagination="false"
              bordered
            >
              <span slot="action" slot-scope="text, record">
                <a @click="orderRemarkEdit(record)">编辑</a>
                <a-divider type="vertical" /><a-popconfirm title="是否要删除此行？" @confirm="removeorderRemark(record)"
                  ><a>删除</a></a-popconfirm
                >
              </span>
            </a-table>
          </div>
          <a-row>
            <a-col :span="20">
              <a-row style="margin-left: -4.5px;margin-left: 20px;">
                <a-col :span="20">
                  <a-form-item
                    label="师傅备注"
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                    style="width: 100%;margin-left:-55px;"
                  >
                    <a-textarea v-model.trim="noteMasterText" :rows="2" />
                  </a-form-item>
                </a-col>
                <a-col :span="2" style="">
                  <a-button type="primary" style="" @click="Submission()">提交</a-button>
                </a-col>
              </a-row>
            </a-col>
          </a-row>
        </a-col>
      </a-row>
    </a-modal>
    <a-modal v-model="editRemarkble" :confirmLoading="editLoading" @ok="sumbitnote" title="修改备注">
      <a-form :form="form1">
        <a-row>
          <a-col>
            <a-form-item style="display:none">
              <a-input v-decorator="['orderRemarkId']" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注内容">
              <a-input v-decorator="['remarkInfo', { rules: [{ required: true, message: '请输入备注内容!' }] }]" />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
    <a-modal v-model="ordersSortible" title="订单排序" @ok="addordersSort()">
      <a-row>
        <a-col
          :span="12"
          style="margin: 5px;overflow: hidden;overflow-y: scroll;border: 1px solid #ccc;width: 350px;padding: 20px;height:400px"
        >
          <a-row v-for="(item, i) in columns" :key="item.dataIndex" style="padding-top: 20px">
            <a-col :span="10">
              <a-radio-group v-model="sortValue" @change="onChangeradio">
                <a-radio :style="radioStyle" :value="item.dataIndex">
                  {{ item.title }}
                </a-radio>
              </a-radio-group>
            </a-col>
            <br />
          </a-row>
        </a-col>
      </a-row>
      <a-row type="flex" justify="space-between">
        <a-col :span="1" style="display: flex;justify-content: space-between;"> </a-col>
        <a-col :span="6" style="width: 90%">
          <a-button type="primary" @click="sortUp">
            上移
          </a-button>
          <a-button type="primary" style="margin-left: 18px;" @click="sortDown">
            下移
          </a-button>
        </a-col>
      </a-row>
    </a-modal>
    <edit-master-order-list ref="masterDetail" @ok="query"></edit-master-order-list>
    <master-leaflets-distribute-model ref="leaflets" @ok="query()"></master-leaflets-distribute-model>
  </a-card>
</template>

<script>
import { checkPermission } from '@/utils/permissions'
import { STable } from '@/components'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import store from '@/store'
import moment from 'moment'
import {
  getselectChannel,
  getselectSource,
  getselectCombox,
  getenterpriseInstallTypes
} from '@/api/order/NewlyaddedOrderList'
import {
  getfinddictAll,
  getOrderList,
  getselectAllProvince,
  getOrderTypeList,
  getselectCityName,
  getselectAreaName,
  getSelectBrand,
  getSelectModel,
  getMasterRemark,
  deleteMasterRemark,
  addMasterRemark,
  updateMasterRemark,
  getOrderDetails,
  getUserOrderSort,
  getaddUserOrderSort,
  getorderInfo,
  receiveOrder
} from '@/api/order/MasterOrderList'
import editMasterOrderList from './modules/editMasterOrderList'
import masterLeafletsDistributeModel from './modules/MasterLeafletsDistributeModel'

const optionsradio = [
  { label: '小时', value: '0' },
  { label: '天', value: '1' }
]

export default {
  name: 'MasterOrderList',
  components: {
    STable,
    editMasterOrderList,
    masterLeafletsDistributeModel
  },
  data() {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      store,
      form: this.$form.createForm(this),
      form1: this.$form.createForm(this),
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return getOrderList(Object.assign(parameter, this.queryParam))
      },
      queryParam: {},
      checkboxlist: {
        isOverTimeOrder: false
      },
      // 表头
      columns: [
        {
          title: '序号',
          dataIndex: 'no',
          align: 'center'
        },
        {
          title: '操作栏',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          align: 'center'
        },
        {
          title: '状态栏',
          dataIndex: 'orderLevel',
          align: 'center'
        },
        {
          title: '订单号',
          dataIndex: 'orderNo',
          scopedSlots: { customRender: 'orderNo' },
          align: 'center'
        },
        {
          title: '安装类别',
          dataIndex: 'installType',
          align: 'center'
        },
        {
          title: '订单类型',
          dataIndex: 'orderType',
          align: 'center'
        },
        {
          title: '订单状态',
          dataIndex: 'orderStatusName',
          align: 'center'
        },
        {
          title: '安装师傅',
          dataIndex: 'installName',
          align: 'center'
        },
        {
          title: '订单负责人',
          dataIndex: 'orderPrincipal',
          align: 'center'
        },
        {
          title: '企业名称',
          dataIndex: 'enterpriseName',
          align: 'center'
        },
        {
          title: '客户姓名',
          dataIndex: 'clientName',
          scopedSlots: { customRender: 'clientName' },
          align: 'center'
        },
        {
          title: '联系方式',
          dataIndex: 'clientPhone',
          scopedSlots: { customRender: 'clientPhone' },
          align: 'center'
        },
        {
          title: '客户地址',
          dataIndex: 'clientAddress',
          align: 'left'
        },
        {
          title: '预约上门时间',
          dataIndex: 'reserveTime',
          align: 'center'
        },
        {
          title: '销单时间',
          dataIndex: 'saleTime',
          align: 'center'
        },
        {
          title: '核销时间',
          dataIndex: 'checkTime',
          align: 'center'
        },
        {
          title: '订单完成时间',
          dataIndex: 'orderFinishTime',
          align: 'center'
        },
        {
          title: '建单时间',
          dataIndex: 'createTime',
          align: 'center'
        },
        {
          title: '超时时长',
          dataIndex: 'timeOutDuration',
          align: 'center'
        },
        // {
        //   title: '建单人',
        //   dataIndex: 'createBy',
        //   align: 'center'
        // },
        {
          title: '介入时间',
          dataIndex: 'intervenDuration',
          align: 'center'
        }
      ],
      // 师傅备注列表
      mastercolumns: [
        {
          title: '操作',
          dataIndex: 'action',
          width: 120,
          scopedSlots: { customRender: 'action' }
        },
        {
          title: '备注信息',
          dataIndex: 'remarkInfo'
        },
        {
          title: '更新人',
          dataIndex: 'updateBy',
          width: 60
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime',
          width: 160
        }
      ],
      optionsradio, // 时间检索（天、小时）
      installTypes: [], // 安装类别
      order_status: [], // 订单状态
      master_time_type: [], // 时间类型
      // 时间类型检索
      timeType1: null,
      timeType2: null,
      timeType3: null,
      orderTypeList: [], // 订单类型
      selectAllProvince: [], // 省
      selectCityName: [], // 市
      selectAreaName: [], // 区
      selectCombox: [], // 企业名称
      selectBrand: [], // 品牌
      selectModel: [], // 型号
      changeRemarkible: false, // 师傅备注
      editRemarkble: false, // 修改备注
      masterList: [], // 师傅备注内容
      orderValue: '', // 订单信息
      noteMasterText: '', // 添加师傅备注信息
      changeLoading: false, // 添加确定loading
      editLoading: false, // 修改确定loading
      tableLoading: false, // 师傅备注talbe刷新
      ordersSortible: false, // 订单排序
      sortValue: '',
      headers: {
        token: Vue.ls.get(ACCESS_TOKEN)
      }
    }
  },
  created() {
    // 字典表数据
    let dictTypes = [
      'order_substate',
      'install_type',
      'close_order_type',
      'master_order_status',
      'timeout_type',
      'delivery_company',
      'pay_status',
      'worker_type',
      'tech_level',
      'master_time_type',
      'pay_type',
      'settle_role',
      'remove_type'
    ]
    getfinddictAll({ dictTypes: dictTypes.join() }).then(res => {
      this.order_substate = res.order_substate
      // this.installTypes=res.install_type
      this.order_status = res.master_order_status
      this.timeout_type = res.timeout_type
      this.delivery_company = res.delivery_company
      this.pay_status = res.pay_status
      this.worker_type = res.worker_type
      this.tech_level = res.tech_level
      this.pay_type = res.pay_type
      this.settle_role = res.settle_role
      this.remove_type = res.remove_type
      this.close_order_type = res.close_order_type
      this.master_time_type = res.master_time_type
    })
    // 所有省
    getselectAllProvince().then(res => {
      if (res.code === 0) {
        this.selectAllProvince = res.rows
      } else {
        this.$message.error(res.msg)
      }
    })
    // 企业名称
    getselectCombox().then(res => {
      if (res.code === 0) {
        this.selectCombox = res.data
      } else {
        this.$message.error(res.msg)
      }
    })
    this.userOrderSort()
  },
  mounted() {
    // 首页跳转带来的ID
    let menuId = this.$route.params.id
    // 检索条件
    let jumpList = this.$route.params.jumpList
    // console.log(menuId,jumpList)
    if (jumpList) {
      this.queryParam = {}
      this.queryParam = {
        orderStatus: undefined
      }
      this.checkboxlist = {
        isOverTimeOrder: false
      }
      this.queryParam.orderStatus = jumpList.orderStatus
      this.checkboxlist.isOverTimeOrder = jumpList.timeOutType == 1 ? true : false
      this.queryParam.isOverTimeOrder = jumpList.timeOutType
      this.$nextTick(() => {
        setTimeout(() => {
          this.query()
        }, 600)
      })
    }
  },
  methods: {
    moment,
    // 编辑
    handleEdit(record) {
      this.$refs.masterDetail.handleEdit(record, this.selectAllProvince)
    },
    // 点击订单号
    addremark(record) {
      if (record) {
        this.tableLoading = true
        this.orderValue = record
        this.noteMasterText = ''
        getMasterRemark({ orderId: record.orderId }).then(res => {
          if (res.code == 0) {
            this.masterList = res.rows
            this.tableLoading = false
          }
        })
        this.changeRemarkible = true
      }
    },
    // 添加师傅备注
    Submission() {
      if (this.noteMasterText != '') {
        addMasterRemark({
          orderId: this.orderValue.orderId,
          remarkInfo: this.noteMasterText,
          orderStatus: this.orderValue.orderStatus
        }).then(res => {
          if (res.code == 0) {
            this.tableLoading = true
            getMasterRemark({ orderId: this.orderValue.orderId }).then(res => {
              if (res.code == 0) {
                this.masterList = res.rows
                this.tableLoading = false
                this.noteMasterText = ''
              }
            })
          }
        })
      } else {
        this.$message.error('请输入备注内容')
      }
    },
    // 编辑师傅备注
    orderRemarkEdit(record) {
      this.editRemarkble = true
      this.$nextTick(() => {
        this.form1.setFieldsValue({ orderRemarkId: record.orderRemarkId, remarkInfo: record.remarkInfo })
      })
    },
    // 提交修改备注
    sumbitnote() {
      this.editLoading = true
      this.form1.validateFields((err, values) => {
        if (!err) {
          // console.log('Received values of form: ', values);
          updateMasterRemark(values).then(res => {
            if (res.code == 0) {
              this.tableLoading = true
              this.$message.success('修改成功')
              this.editRemarkble = false
              this.editLoading = false
              getMasterRemark({ orderId: this.orderValue.orderId }).then(res => {
                if (res.code == 0) {
                  this.masterList = res.rows
                  this.tableLoading = false
                }
              })
            }
          })
        }
      })
    },
    // 删除师傅备注
    removeorderRemark(record) {
      deleteMasterRemark({ orderRemarkId: record.orderRemarkId }).then(res => {
        if (res.code === 0) {
          this.tableLoading = true
          this.$message.success('删除成功')
          getMasterRemark({ orderId: this.orderValue.orderId }).then(res => {
            if (res.code == 0) {
              this.masterList = res.rows
              this.tableLoading = false
            }
          })
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 初始排序
    userOrderSort() {
      getUserOrderSort().then(res => {
        // console.log(res.data)
        if (res.code === 0) {
          if (res.data.length > 0) {
            for (let col of res.data) {
              col.align = 'center'
              if (col.dataIndex == 'action') {
                col['scopedSlots'] = { customRender: 'action' }
                col.align = 'left'
              }
              if (col.dataIndex == 'orderNo') {
                col['scopedSlots'] = { customRender: 'orderNo' }
              }
              if (col.dataIndex == 'clientName') {
                col['scopedSlots'] = { customRender: 'clientName' }
              }
              if (col.dataIndex == 'clientAddress') {
                col['scopedSlots'] = { customRender: 'clientAddress' }
                col.align = 'left'
              }
            }
            this.columns = res.data
          }
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    ordersSort() {
      this.ordersSortible = true
    },
    // 上移
    sortUp() {
      for (let i = 0; i < this.columns.length; i++) {
        if (this.columns[i].dataIndex == this.sortValue) {
          if (i != -1 && i != 0) {
            ;[this.columns[i - 1], this.columns[i]] = [this.columns[i], this.columns[i - 1]]
          }
          let keys = []
          this.columns.forEach(key => keys.push(key))
          this.columns = keys
        }
      }
    },
    // 下移
    sortDown() {
      for (let i = this.columns.length - 1; i >= 0; i--) {
        if (this.columns[i].dataIndex == this.sortValue) {
          if (i != -1 && i != this.columns.length - 1) {
            ;[this.columns[i + 1], this.columns[i]] = [this.columns[i], this.columns[i + 1]]
          }
          let keys = []
          this.columns.forEach(key => keys.push(key))
          this.columns = keys
        }
      }
    },
    // 提交排序
    addordersSort() {
      getaddUserOrderSort(this.columns).then(res => {
        if (res.code === 0) {
          this.ordersSortible = false
          this.query()
          this.$message.success('操作成功')
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 企业关联品牌/安装类别
    handleEnterPrise(e) {
      this.form.setFieldsValue({
        installType: undefined,
        brandId: undefined,
        modelId: undefined
      })
      this.installTypes = []
      this.orderTypeList = []
      this.selectBrand = []
      this.selectModel = []
      // 品牌
      getSelectBrand({ enterpriseId: e }).then(res => {
        if (res.code === 0) {
          this.selectBrand = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
      // 安装类别
      getenterpriseInstallTypes({ enterpriseId: e }).then(res => {
        if (res.code === 0) {
          this.installTypes = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 品牌关联型号
    changeBrandName(e) {
      this.form.setFieldsValue({ modelId: undefined })
      if (e) {
        getSelectModel({
          brandId: e
        }).then(res => {
          if (res.code === 0) {
            this.selectModel = res.data
          } else {
            this.$message.error(res.msg)
          }
        })
      } else {
        this.selectModel = []
      }
    },
    // 安装类型关联订单类型
    changeInstall(e) {
      this.form.setFieldsValue({ orderType: undefined })
      getOrderTypeList(e).then(res => {
        if (res.code === 0) {
          this.orderTypeList = res.rows
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 省
    getProvince(e) {
      this.selectCityName = []
      this.selectAreaName = []
      this.form.setFieldsValue({
        customerCityCode: undefined,
        customerAreaCode: undefined,
        customerDetailAddress: undefined
      })
      getselectCityName({ provinceCode: e }).then(res => {
        this.selectCityName = res.rows
      })
    },
    // 市
    getCityName(e) {
      this.selectAreaName = []
      this.form.setFieldsValue({ customerAreaCode: undefined, customerDetailAddress: undefined })
      getselectAreaName({ cityCode: e }).then(res => {
        this.selectAreaName = res.rows
      })
    },
    // 区
    getAreaName(e) {
      this.form.setFieldsValue({ customerDetailAddress: '' })
    },
    // 日期控件1
    onChangerangepicker(date, dateString) {
      this.queryParam.timeStart1 = dateString[0]
      this.queryParam.timeEnd1 = dateString[1]
    },
    // 日期控件2
    onChangerangepicker2(date, dateString) {
      this.queryParam.timeStart2 = dateString[0]
      this.queryParam.timeEnd2 = dateString[1]
    },
    // 日期控件3
    onChangerangepicker3(date, dateString) {
      this.queryParam.timeStart3 = dateString[0]
      this.queryParam.timeEnd3 = dateString[1]
    },
    // 是否超时订单
    overTimeOrder(e) {
      console.log(e)
      this.$set(this.checkboxlist, 'isOverTimeOrder', e.target.checked)
      // this.queryParam.isMyOrder=e.target.checked?'1':'0'
    },
    // 订单状态
    changeOrderStatus(e) {
      this.$set(this.queryParam, this.queryParam.orderStatus, e)
    },
    // 查询
    query() {
      this.queryParam.installType = this.form.getFieldValue('installType')
      this.queryParam.orderType = this.form.getFieldValue('orderType')
      this.queryParam.brandId = this.form.getFieldValue('brandId')
      this.queryParam.modelId = this.form.getFieldValue('modelId')
      this.queryParam.province = this.form.getFieldValue('customerProvinceCode')
      this.queryParam.cityId = this.form.getFieldValue('customerCityCode')
      this.queryParam.countyId = this.form.getFieldValue('customerAreaCode')
      this.queryParam.clientAddress = this.form.getFieldValue('customerDetailAddress')
      this.queryParam.isOverTimeOrder = this.checkboxlist.isOverTimeOrder ? '1' : '0'
      this.$nextTick(() => {
        this.$refs.table.refresh(true)
      })
    },
    // 清空
    handleClear() {
      this.form.resetFields()
      this.timeType1 = null
      this.timeType2 = null
      this.timeType3 = null
      this.selectCityName = []
      this.selectAreaName = []
      this.queryParam = {}
      this.checkboxlist = {}
    },
    // 复制
    Copys(val) {
      this.copyData =
        `订单号:` +
        val.orderNo +
        '\n' +
        `客户姓名:` +
        val.clientName +
        '\n' +
        `客户联系方式:` +
        val.clientPhone +
        '\n' +
        `客户地址:` +
        val.clientAddress
      this.handcopy(this.copyData)
    },
    Copys2(val) {
      this.copyData =
        `客户姓名:` + val.clientName + '\n' + `客户联系方式:` + val.clientPhone + '\n' + `客户地址:` + val.clientAddress
      this.handcopy(this.copyData)
    },
    handcopy(data) {
      let url = data
      let oInput = document.createElement('textArea')
      oInput.value = url
      document.body.appendChild(oInput)
      oInput.select() // 选择对象;
      console.log(oInput.value)
      document.execCommand('Copy') // 执行浏览器复制命令
      this.$message.success('复制成功')
      oInput.remove()
    },
    // 下拉搜索
    filterOption(input, option) {
      if (option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    },
    //导出
    exportEnt2() {
      // console.log('this.queryParam',this.queryParam)
      this.$axios({
        method: 'get',
        url: '/api/order/order/masterOrderExport',
        params: this.queryParam,
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN),
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then(res => {
        console.log(res)
        if (res.data.code == 500) {
          this.$message.error(res.data.msg)
        } else {
          var str = process.env.VUE_APP_API_BASE_URL + '/order/order/masterOrderExport?'
          for (let i in this.queryParam) {
            if (this.queryParam[i] != undefined) {
              str = str + '&' + i + '=' + this.queryParam[i]
            }
          }
          str = str + '&token=' + this.headers.token
          window.open(str)
        }
      })
    },
    distribute(record) {
      getorderInfo({ orderId: record.orderId }).then(res => {
        if (res.code === 0) {
          debugger
          res.data.orderStatusName = record.orderStatusName
          this.$refs.leaflets.showleaflets(res.data)
        } else {
          this.$message.error(res.msg)
        }
      })
    },

    orderReceive(record) {
      receiveOrder({
        applyResult: '0',
        orderId: record.orderId,
        procInstId: record.procInstId,
        reasonContext: ''
      }).then(res => {
        this.$message.success('接单成功')
        this.$refs.table.refresh(true)
      })
    }
  },
  watch: {
    $route(to, from) {
      if (to.path == '/order/MasterOrderList') {
        // console.log('师傅订单',to,from)
        // 首页跳转带来的ID
        let menuId = this.$route.params.id
        // 检索条件
        let jumpList = this.$route.params.jumpList
        if (jumpList) {
          this.queryParam = {}
          this.queryParam = {
            orderStatus: undefined
          }
          this.checkboxlist = {
            isOverTimeOrder: false
          }
          this.queryParam.orderStatus = jumpList.orderStatus
          this.checkboxlist.isOverTimeOrder = jumpList.timeOutType == 1 ? true : false
          this.queryParam.isOverTimeOrder = jumpList.timeOutType
          this.$nextTick(() => {
            this.query()
          })
        }
      }
    }
  }
}
</script>

<style scoped>
/deep/ .ant-table th {
  white-space: nowrap;
}
/deep/ .ant-table td {
  white-space: nowrap;
  padding: 4px 16px;
}
</style>
